import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Layout from '../components/Layout';

const NotFoundPage = () => {
    const location = useLocation();

    return (
        <Layout>
            <div className="px-4 py-12 max-w-lg mx-auto text-center">
                <h1 className="text-2xl font-bold text-gray-900 mb-2">Page not found</h1>
                <p className="text-gray-600 mb-2">
                    No route matches <span className="font-mono text-sm">{location.pathname}</span>.
                </p>
                <p className="text-sm text-gray-500 mb-6">
                    If this is a new page, redeploy the latest client build to the server.
                </p>
                <Link
                    to="/main-dashboard"
                    className="inline-block px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                    Back to Main Dashboard
                </Link>
            </div>
        </Layout>
    );
};

export default NotFoundPage;
